import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { createMapSettings } from "../../services/network/map_settings-api";
import { MapSettingsCreate } from "../../services/models/map_settings";

export function useCreateMapSettings(isNotShowUpdatingMessage?: boolean) {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationKey: ["/map_settings/create"],
    mutationFn: (mapSettings: MapSettingsCreate) => createMapSettings(mapSettings),
    onError() {
      toast.error("Ошибка создания настройки показателей");
    },
    onSuccess() {
      if (!isNotShowUpdatingMessage) {
        toast.success("Настройки показателей созданы");
      }

      queryClient.invalidateQueries({
        queryKey: ["/map_settings"],
      });
    },
  });

  return {
    createdMapSettings: mutate,
  };
}
